import { useAtlas } from './useAtlas';

/**
 * The atlas for the learner's current biome.
 *
 * The atlas id IS the biome key (e.g. 'bamboo-forest'), and the authoritative
 * level → biome mapping lives in the backend (mapService returns biome_key via
 * useMapData). So this hook takes the biome key from that output rather than
 * re-deriving level → biome on the frontend, which would duplicate backend logic
 * and risk drift.
 *
 * @param {string} biomeKey  from useMapData().biome_key
 * @returns {{ atlas: object|undefined, isLoading: boolean }}
 */
export function useCurrentAtlas(biomeKey) {
  const key = biomeKey || 'bamboo-forest';
  const { data: atlas, isLoading } = useAtlas(key);
  return { atlas, isLoading };
}
